<template>
  <v-dialog v-model="consolidar" fullscreen hide-overlay lazy transition="dialog-bottom-transition">
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="!fechado"
        color="red lighten-2"
        dark
        small
        v-on="on"
      >
        CONSOLIDAR
      </v-btn>
      <v-btn
        v-else
        color="success"
        dark
        small
        v-on="on"
      >
        FECHADO
      </v-btn>
    </template>
    <consolidar v-if="consolidacao" @fechar="consolidar = false" :fechado="fechado" :consolidacao="consolidacao" @fecharConsolidacao="fecharConsolidacao"></consolidar>
  </v-dialog>
</template>

<script>
import Consolidar from '@/components/dialogs/ConsolidarAbastecimento'

export default {
  components: { Consolidar },
  props: ['dia', 'fechado'],
  data () {
    return {
      consolidar: false,
      consolidacao: null
    }
  },
  watch: {
    consolidar (val) {
      if (val !== null && val !== undefined & val === true) {
        this.carregarRelatorio()
      }
    }
  },
  computed: {
    consolidado () {
      return false
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    fecharConsolidacao () {
      this.$store.dispatch('fecharConsolidacaoAbastecimento', this.dia).then(() => {
        this.$emit('consolidarAbastecimento', this.dia)
        this.consolidar = false
      })
    },
    carregarRelatorio () {
      this.$store.dispatch('relatorioVouchersCallback', {
        disponivel: false,
        data_inativado: this.dia
      }).then(vouchers => {
        this.consolidacao = {
          competencia: this.dia,
          files: [],
          vouchers: vouchers.map((data) => {
            return {
              apetrus: true,
              pendente: false,
              id_voucher: data.id_voucher,
              consolidada: data.consolidada,
              numero: data.numero,
              data_gerado: data.data_gerado.split('-').reverse().join('/'),
              data_inativado: data.data_inativado ? data.data_inativado.split('-').reverse().join('/') : undefined,
              cliente: {
                nome: data.usuario_utilizador.nome,
                sobrenome: data.usuario_utilizador.sobrenome,
                cpf: data.usuario_utilizador.cpf,
                email: data.usuario_utilizador.email,
                telefone: data.usuario_utilizador.telefone
              },
              combustivel: data.compra.combustivel,
              codigo_cupom: data.codigo_cupom,
              chave_cupom: data.chave_cupom,
              id_compra: data.compra.id_compra,
              valor: data.valor,
              quantidade_litros: data.quantidade_litros
            }
          })
        }
      })
    }
  }
}
</script>
